import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PublicLayout from "@/components/PublicLayout";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Package, ArrowRight, Sparkles, Loader2 } from "lucide-react";

export default function PaquetesCatalog() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/catalog/bundles")
      .then((r) => setItems(r.data.items || []))
      .catch((e) => toast.error(formatApiError(e?.response?.data?.detail)))
      .finally(() => setLoading(false));
  }, []);

  return (
    <PublicLayout>
      <section className="max-w-7xl mx-auto px-4 py-12">
        <div className="text-center max-w-2xl mx-auto mb-10">
          <p className="text-xs uppercase tracking-widest text-[#F26A21] font-bold">Paquetes DCC</p>
          <h1 className="mt-2 text-4xl sm:text-5xl font-extrabold text-[#0B0B0B] font-display">Rutas curadas · más valor por menos</h1>
          <p className="mt-3 text-lg text-gray-600">Combinaciones de 2 a 6 programas con ahorros de hasta 30%. Cada paquete incluye acceso completo a los programas y una cohorte pública por programa.</p>
        </div>

        {loading ? (
          <div className="text-sm text-gray-500 inline-flex items-center gap-2"><Loader2 className="w-4 h-4 animate-spin" /> Cargando…</div>
        ) : items.length === 0 ? (
          <div className="rounded-2xl border border-gray-200 bg-white p-8 text-center text-gray-600">
            Aún no hay paquetes activos.
          </div>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {items.map((b) => (
              <Link key={b.id} to={`/catalogo/paquetes/${b.slug}`}
                    data-testid={`bundle-card-${b.slug}`}
                    className="group flex flex-col p-5 bg-white border border-gray-200 rounded-2xl shadow-sm hover:shadow-lg hover:border-[#F26A21] transition-all hover:-translate-y-1">
                <div className="flex items-start justify-between mb-2">
                  <span className="text-[10px] px-2 py-0.5 rounded bg-[#F26A21] text-[#0B0B0B] uppercase font-bold tracking-widest inline-flex items-center gap-1">
                    <Package className="w-3 h-3" /> Paquete
                  </span>
                  {b.iada_aval_available && (
                    <span className="text-[10px] px-2 py-0.5 rounded border border-[#F26A21] text-[#F26A21] uppercase font-bold tracking-widest inline-flex items-center gap-1">
                      <Sparkles className="w-3 h-3" /> IADA
                    </span>
                  )}
                </div>
                <h3 className="text-lg font-bold text-[#0B0B0B] leading-tight group-hover:text-[#F26A21] transition-colors">{b.title}</h3>
                <p className="mt-2 text-sm text-gray-600 line-clamp-2">{b.description}</p>
                <div className="mt-4">
                  <p className="text-[10px] uppercase tracking-widest text-gray-600 font-semibold">Incluye {b.programs?.length} programas</p>
                  <ul className="mt-1 text-xs text-gray-700 space-y-0.5">
                    {b.programs?.slice(0, 3).map(p => <li key={p.id}>· {p.title}</li>)}
                    {b.programs?.length > 3 && <li className="text-gray-500">+ {b.programs.length - 3} más</li>}
                  </ul>
                </div>
                <div className="mt-4">
                  <p className="text-3xl font-extrabold text-[#0B0B0B] tabular-nums" style={{ letterSpacing: "-0.02em" }}>
                    ${b.bundle_price_mxn.toLocaleString("es-MX")}
                    <span className="ml-1 text-xs font-semibold text-gray-500 uppercase tracking-widest">MXN</span>
                  </p>
                  <p className="mt-1 text-sm text-gray-600">
                    <span className="line-through text-gray-400">${b.individual_total_mxn.toLocaleString("es-MX")}</span>
                    <span className="ml-2 inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-emerald-500/10 text-emerald-800 border border-emerald-500/30 text-[10px] font-bold uppercase tracking-wider">
                      Ahorras ${b.savings_mxn.toLocaleString("es-MX")} · {b.savings_pct}%
                    </span>
                  </p>
                </div>
                <div className="mt-auto pt-4">
                  <span className="inline-flex items-center gap-1 text-xs px-3 py-1.5 rounded-md border border-[#F26A21] text-[#F26A21] font-semibold">
                    Ver paquete <ArrowRight className="w-3 h-3" />
                  </span>
                </div>
              </Link>
            ))}
          </div>
        )}
      </section>
    </PublicLayout>
  );
}
